import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full" }
const _hoisted_2 = { class: "flex items-center m-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Skyline Platform ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ADMIN ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" STUDENT ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" INSTRUCTOR ")

import { storeToRefs } from 'pinia';
import { useGlobalStore } from '../store/globalStore';
import Routes from '../router/Routes';
import Icon from '../components/icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { firebaseUser, currentUser } = storeToRefs(useGlobalStore());

return (_ctx: any,_cache: any) => {
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_button_component = _resolveComponent("login-button-component")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "flex items-center mr-8 text-2xl font-semibold",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_icon_component, {
              icon: _unref(Icon).LOGO,
              class: "mr-2"
            }, null, 8, ["icon"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "flex items-center mr-8 text-2xl font-semibold",
          to: _unref(Routes).ADMIN
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "flex items-center mr-8 text-2xl font-semibold",
          to: _unref(Routes).STUDENT
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "flex items-center mr-8 text-2xl font-semibold",
          to: _unref(Routes).INSTRUCTOR
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(_component_login_button_component, {
        class: "m-4 ml-auto text-xs",
        isLoggedIn: _unref(currentUser) !== null,
        isEmailVerified: _unref(firebaseUser)?.emailVerified,
        currentUser: _unref(currentUser)
      }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
    ])
  ]))
}
}

})